import { DetailPageActionTypes } from './constants'
import { store } from '../store'
import { isMovieSelector } from '../selectors/detailFragment'
import { refreshMainActionBox, refreshEpisode, refreshBtfActionBoxes } from './wps'

export type TriggerPurchasingTransition = {
  offerAsin: string,
  canonicalTitleId: string | undefined,
  isSeasonPurchase: boolean,
  purchasingText: string,
  errorHeader: string,
}

export type RemoveActionBoxTransitionPayload = {
  offerAsin?: string,
  canonicalTitleId?: string,
}

export interface ITriggerPurchasingTransition {
  type: typeof DetailPageActionTypes.TriggerPurchasingTransition
  payload: TriggerPurchasingTransition
}

export interface IResetPurchasingTransition {
  type: typeof DetailPageActionTypes.ResetPurchasingTransition
  payload: RemoveActionBoxTransitionPayload
}

export interface IFailedPurchasingDueToClientDependency {
  type: typeof DetailPageActionTypes.FailedPurchasingDueToClientDependency
  payload: RemoveActionBoxTransitionPayload
}

export const triggerPurchasingTransition = (payload: TriggerPurchasingTransition): ITriggerPurchasingTransition => ({
  type: DetailPageActionTypes.TriggerPurchasingTransition,
  payload
})

export const resetPurchasingTransition = (payload: RemoveActionBoxTransitionPayload) => ({
  type: DetailPageActionTypes.ResetPurchasingTransition,
  payload,
})

export const failedPurchasingDueToClientDependency = (payload: RemoveActionBoxTransitionPayload) => ({
  type: DetailPageActionTypes.FailedPurchasingDueToClientDependency,
  payload,
})

export const refreshActionBoxes = (titleId?: string) => {
  const state = store.getState()
  const { pageTitleId } = state

  const promises = [refreshMainActionBox(state.pageTitleId)]
  if (!isMovieSelector(state)) {
      promises.push(
        titleId ? refreshEpisode(titleId) : refreshBtfActionBoxes(pageTitleId)
      )
  }

  return Promise.all(promises)
}